import { Col } from "antd";
import CompanyTreeView from "../components/CompanyTreeView";

export function CompanyTreePage() {
  return (
    <Col className="relative flex flex-auto flex-col overflow-hidden overflow-y-auto">
      <Col className="flex flex-auto flex-col overflow-hidden p-4 pb-4 pt-0">
        <CompanyTreeView />
      </Col>
    </Col>
  );
}

export default CompanyTreePage;
